// extracted by mini-css-extract-plugin
export var suptitle = "styles-module--suptitle--a49f4";